import React, {Component} from 'react'
import PropTypes from 'prop-types'

import isAnalyticsUpdated from '../utils/isAnalyticsUpdated'
import {SnowplowReactContext} from '../SnowplowContextManager'
import {getSnoplowAnalytics} from './utils'

const withSnowplowLifecycle = (
  WrappedComponent,
  snowplowEvent,
  options = null
) =>
  class extends Component {
    static contextType = SnowplowReactContext
    static propTypes = {
      analyticsOptions: PropTypes.object,
      analyticsContexts: PropTypes.array,
      overwriteContexts: PropTypes.bool
    }
    static defaultProps = {
      analyticsOptions: null,
      analyticsContexts: [],
      overwriteContexts: false
    }

    static displayName = `${WrappedComponent.displayName}WithSnowplowLifecycle`

    constructor(props, context) {
      super(props, context)

      this.state = {analytics: this.getAnalytics()}
    }

    getAnalytics = () =>
      getSnoplowAnalytics(
        Object.assign({}, this.props, {snowplowEvent}),
        this.context,
        options
      )

    componentDidUpdate() {
      /* Updates state if props.analyticsContexts, analyticsOptions or React context changed. */
      if (isAnalyticsUpdated(this.getAnalytics(), this.state.analytics)) {
        this.setState({analytics: this.getAnalytics()})
      }
    }

    render() {
      // Prevent next props from passing down to child component
      // since they are not used there and cause a lot of warnings
      const {analyticsContexts, analyticsOptions, overwriteContexts, ...props} = this.props
      const {analytics} = this.state

      return <WrappedComponent analytics={analytics} {...props} />
    }
  }

export default withSnowplowLifecycle
